var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import http, { Q } from "@http";
import { observable, action, runInAction, computed } from "mobx";
import BaseStore from "./base";
import { LinkObjectTypeData, WOReferenceType, WorkCompletedStatusType } from "@containers/woRating/common/enums";
var WoRatingStore = /** @class */ (function (_super) {
    __extends(WoRatingStore, _super);
    function WoRatingStore() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.confirmDetailData = {};
        _this.loading = false;
        _this.woId = '';
        _this.refType = null;
        _this.woNum = '';
        _this.workCompletedStatus = null;
        _this.notCompletedComments = '';
        _this.rate = null;
        _this.easySchedulingRate = null;
        _this.technicianRate = null;
        _this.rateComments = '';
        _this.recommendationRate = null;
        return _this;
    }
    Object.defineProperty(WoRatingStore.prototype, "isSubmitDisabled", {
        get: function () {
            return !this.workCompletedStatus;
        },
        enumerable: false,
        configurable: true
    });
    WoRatingStore.prototype.commit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var params, promise, data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = this.workCompletedStatus === WorkCompletedStatusType.YES ?
                            {
                                refId: this.woId,
                                refType: Number(this.refType) === LinkObjectTypeData.RecurrentWo ? WOReferenceType.RecurrentWO : WOReferenceType.ReactiveWO,
                                workCompletedStatus: this.workCompletedStatus,
                                rate: this.rate,
                                rateComments: this.rateComments,
                                easySchedulingRate: this.easySchedulingRate,
                                technicianRate: this.technicianRate,
                                recommendationRate: this.confirmDetailData.npsActive ? this.recommendationRate : null,
                                npsActive: this.confirmDetailData.npsActive
                            } :
                            {
                                refId: this.woId,
                                refType: Number(this.refType) === LinkObjectTypeData.RecurrentWo ? WOReferenceType.RecurrentWO : WOReferenceType.ReactiveWO,
                                workCompletedStatus: this.workCompletedStatus,
                                notCompletedComments: this.notCompletedComments
                            };
                        this.loading = true;
                        promise = this.api().commit(params);
                        return [4 /*yield*/, promise];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            _this.loading = false;
                        });
                        return [2 /*return*/, promise];
                }
            });
        });
    };
    WoRatingStore.prototype.clearAll = function () {
        this.workCompletedStatus = null;
        this.notCompletedComments = '';
        this.rate = null;
        this.easySchedulingRate = null;
        this.technicianRate = null;
        this.rateComments = '';
        this.recommendationRate = null;
    };
    WoRatingStore.prototype.getConfirmDetail = function (woId, type) {
        return __awaiter(this, void 0, void 0, function () {
            var params, promise, data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.woId = woId;
                        this.refType = type;
                        params = {
                            woId: woId,
                            type: Number(type) === LinkObjectTypeData.RecurrentWo ? WOReferenceType.RecurrentWO : WOReferenceType.ReactiveWO
                        };
                        this.loading = true;
                        promise = this.api().getConfirmDetail(params);
                        return [4 /*yield*/, promise];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            _this.confirmDetailData = data;
                            _this.woNum = data.woNum;
                            _this.loading = false;
                        });
                        return [2 /*return*/, promise];
                }
            });
        });
    };
    WoRatingStore.prototype.api = function () {
        return {
            getConfirmDetail: function (params) {
                return Q(http.get("/RSP/Request/GetConfirmDetail", { params: params }));
            },
            commit: function (params) {
                return Q(http.post("/RSP/Request/ResidentsCompleteRate", params));
            },
            getRatingToggle: function (params) {
                return Q(http.get("/RSP/Request/IsResidentRating", { params: params }));
            }
        };
    };
    __decorate([
        observable
    ], WoRatingStore.prototype, "confirmDetailData", void 0);
    __decorate([
        observable
    ], WoRatingStore.prototype, "loading", void 0);
    __decorate([
        observable
    ], WoRatingStore.prototype, "woId", void 0);
    __decorate([
        observable
    ], WoRatingStore.prototype, "refType", void 0);
    __decorate([
        observable
    ], WoRatingStore.prototype, "woNum", void 0);
    __decorate([
        observable
    ], WoRatingStore.prototype, "workCompletedStatus", void 0);
    __decorate([
        observable
    ], WoRatingStore.prototype, "notCompletedComments", void 0);
    __decorate([
        observable
    ], WoRatingStore.prototype, "rate", void 0);
    __decorate([
        observable
    ], WoRatingStore.prototype, "easySchedulingRate", void 0);
    __decorate([
        observable
    ], WoRatingStore.prototype, "technicianRate", void 0);
    __decorate([
        observable
    ], WoRatingStore.prototype, "rateComments", void 0);
    __decorate([
        observable
    ], WoRatingStore.prototype, "recommendationRate", void 0);
    __decorate([
        computed
    ], WoRatingStore.prototype, "isSubmitDisabled", null);
    __decorate([
        action.bound
    ], WoRatingStore.prototype, "commit", null);
    __decorate([
        action.bound
    ], WoRatingStore.prototype, "clearAll", null);
    __decorate([
        action.bound
    ], WoRatingStore.prototype, "getConfirmDetail", null);
    return WoRatingStore;
}(BaseStore));
export default WoRatingStore;
